import SharedRoutesDefinitions from './SharedRoutesDefinitions';
import RouteNames from '../RouteNames';

const RoutesSsp = [
  {
    path: '/administration/:systemId(\\d+)/calculated/termVirtual',
    name: 'termVirtual',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/dataSource/datalogger/:path',
    name: 'datalogger',
    component: () => import('../../components/renderer/DataloggerSspRenderer.vue'),
  },
  {
    ...SharedRoutesDefinitions[RouteNames.DATASOURCE_DATALOGGER_OVERVIEW],
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/dataSource/dataloggerRestore',
    name: 'dataloggerRestore',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/measuredValueCopy',
    name: 'measuredValueCopy',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/systemConfiguration',
    name: 'systemConfiguration',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/systemData',
    name: 'systemData',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/responsibilities',
    name: 'responsibilities',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/residential',
    name: 'residential',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/publicConfiguration',
    name: 'publicConfiguration',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/technicalData/systemProfile',
    name: 'systemProfile',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/meterManagement',
    name: 'meterManagement',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/monitoring',
    name: 'monitoring',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/monitoring/:page',
    name: 'monitoringPage',
    component: () => import('../../components/renderer/MonitoringSspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/anomaly',
    name: 'anomaly',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/contractStatus',
    name: 'contractStatus',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/reportSystem',
    name: 'reportSystem',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/publicActivation',
    name: 'publicActivation',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/cooperation',
    name: 'cooperation',
    component: () => import('../../components/renderer/SspRenderer.vue'),
  },
];

export default RoutesSsp;
